import cart from './cart';

export default {cart}